<template>
  <CommonPopup ref="refCommonPopup">
    <div class="input-popup">
      <div class="input-popup-content">
        <div class="input-title">请输入{{ text }}</div>
        <van-field
          ref="refTempValueField"
          class="input-popup-field"
          v-model="tempValue"
          required
          size="large"
          :type="inputType"
          :placeholder="`请输入${text}`"
          :clearable="true"
          :autofocus="true"
        />
      </div>
      <div class="input-popup-btns">
        <div
          class="input-popup-btn btn-default"
          @click="handleCancel"
        >
          取消
        </div>
        <div
          class="input-popup-btn btn-primary"
          @click="handleConfirm"
        >
          确定
        </div>
      </div>
    </div>
  </CommonPopup>
</template>

<script>
import CommonPopup from './CommonPopup';
import { REGEX_PHONE } from '@/common/regex';

export default {
  name: 'InputPopup',
  components: {
    CommonPopup
  },
  props: {
    max: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    min: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      tempValue: '',
      key: '',
      text: '',
      inputType: 'text'
    };
  },
  methods: {
    openPopup(option) {
      this.tempValue = option.value || '';
      this.key = option.key || '';
      this.text = option.text || '';
      this.inputType = option.inputType || 'text';
      this.$refs.refCommonPopup.openPopup();
      this.$nextTick(() => {
        this.$refs.refTempValueField?.focus();
      });
    },
    closePopup() {
      this.tempValue = '';
      this.key = '';
      this.text = '';
      this.inputType = 'text';
      this.$refs.refCommonPopup.closePopup();
    },
    handleConfirm() {
      if (!this.tempValue) {
        this.$toast('请输入有效值');
        return;
      }
      if (this.inputType === 'tel' && !REGEX_PHONE.test(this.tempValue)) {
        this.$toast('输入值应为有效手机号');
        return;
      }
      if (this.key === 'buyNum') {
        if (this.tempValue <= this.min) {
          this.tempValue = this.min;
        } else if (this.tempValue >= this.max) {
          this.tempValue = this.max;
        }
      }

      const param = {
        key: this.key,
        value: this.tempValue
      };
      this.$emit('confirm', param);
      this.closePopup();
    },
    handleCancel() {
      this.$emit('cancel');
      this.closePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.input-popup {
  background : #FFFFFF;
  border-radius : 20px;
  width : 600px;
  height : 360px;
  box-sizing : border-box;
  padding : 32px;
  display : flex;
  flex-direction : column;
  align-items : center;
  justify-content : space-between;

  .input-popup-content {
    margin-bottom : 24px;
    width : 100%;

    .input-title {
      font-size : 32px;
      color : #383838;
      text-align : center;
      font-weight : 400;
      line-height : 45px;
      margin-bottom : 48px;
      font-weight: bold;
    }
    .input-popup-field {
      border : 1px solid #E5E5E5;
      border-radius : 20px;
      font-size : 24px;
      height : 90px;
      ::v-deep .van-cell--required::before {
        vertical-align : top;
        margin-top : 0px;
      }
      ::v-deep .van-cell__value {
        vertical-align : top;
        margin-top : -4px;
      }
    }
  }
  .input-popup-btns {
    display : flex;
    align-items : center;
    justify-content : space-between;
    width : 100%;

    .input-popup-btn {
      width : 252px;
      height : 90px;
      border-radius : 20px;
      font-size : 32px;
      font-weight : 400;
      display : flex;
      align-items : center;
      justify-content : center;

      &.btn-default {
        border : 1px solid rgba(200, 200, 200, 1);
        background : #FFFFFF;
        color : #383838;
      }
      &.btn-primary {
        background : #FE7256;
        color : #FFFFFF;
      }
    }
  }
  .text-orange {
    color : #FF722C !important;
  }
}
::v-deep .van-field__control {
  font-size : 28px;
  height : 50px;
}

</style>
